import React from "react";
import { Link } from "react-router-dom";
import { Phone, ChevronRight } from "lucide-react";
import { site } from "../../mock";
import { CallbackButton } from "../PageBlocks";

export default function CTASection() {
  return (
    <section className="py-20 hero-radial">
      <div className="container-narrow text-center">
        <h2 className="font-display text-3xl md:text-5xl gold-gradient-text mb-4">Le premier pas vers votre lumière</h2>
        <p className="text-gold-soft/95 max-w-2xl mx-auto mb-8 leading-relaxed">
          Un appel de quelques minutes peut suffire à changer le cours de votre vie. Maître Diamma vous écoute, sans jugement, dans une confidentialité absolue.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <CallbackButton id="home-cta" context="Accueil" />
          <a href={`tel:${site.phoneRaw}`} className="btn-gold rounded-md px-6 py-3 flex items-center gap-2">
            <Phone className="w-4 h-4" /> {site.phone}
          </a>
          <a href={site.whatsapp} target="_blank" rel="noreferrer" className="btn-ghost-gold rounded-md px-6 py-3">
            Écrire sur WhatsApp
          </a>
          <Link to="/contact" className="btn-ghost-gold rounded-md px-6 py-3 flex items-center gap-2">
            Demander un rappel <ChevronRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
